// extracted by mini-css-extract-plugin
export default {"root":"ProductIdentifiersList_root__oqqQ3","header":"ProductIdentifiersList_header__ikSNS","searchInput":"ProductIdentifiersList_searchInput__Z4poT"};